import { motion } from "framer-motion";
import { openWhatsApp, CONTACT } from "@/data/site";
import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => (
  <motion.button
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.4, duration: 0.5, ease: [0.65, 0, 0.35, 1] }}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    onClick={() => openWhatsApp()}
    className="fixed bottom-6 right-6 z-40 group"
    data-testid="whatsapp-float"
    aria-label={`Chat with Thermo Edge on WhatsApp at ${CONTACT.phoneDisplay}`}
  >
    <div className="absolute inset-0 bg-edge rounded-full blur-xl opacity-40 group-hover:opacity-70 transition-opacity" />
    <div className="relative flex items-center gap-3 bg-edge text-ink-950 pl-4 pr-5 py-3 rounded-full shadow-2xl border border-edge">
      <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
      <span className="hidden sm:inline font-bold tracking-wide text-sm uppercase">
        WhatsApp Us
      </span>
    </div>
  </motion.button>
);

export default WhatsAppFloat;
